import type { PracticeAgentReportData } from '../../types'
import { formatFieldReferencesInText, formatMetricValue } from '../../utils'
import { PaginationBar } from './PaginationBar'

export function TableViz({ data, onSelect, onPageChange }: { data: PracticeAgentReportData; onSelect?: (field: string, value: string) => void; onPageChange?: (p: number) => void }) {
  if (data.rows.length === 0) return <p className="text-sm text-gray-400 py-4">No rows to display.</p>
  const firstDimCol = data.columns[0]
  return (
    <div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-100 bg-gray-50/50">
              {data.columns.map((c) => (
                <th key={c} className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wide whitespace-nowrap">
                  {formatFieldReferencesInText(c)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.rows.map((row, i) => (
              <tr
                key={i}
                className={`border-b border-gray-50 transition-colors ${onSelect ? 'feature-hover-surface cursor-pointer' : 'hover:bg-gray-50/70'}`}
                onClick={() => {
                  if (!onSelect || !firstDimCol) return
                  const val = row[firstDimCol]
                  if (val !== null && val !== undefined) onSelect(firstDimCol, String(val))
                }}
              >
                {data.columns.map((c) => {
                  const val = row[c]
                  const isNum = typeof val === 'number'
                  return (
                    <td key={c} className={`px-3 py-2 text-gray-700 ${isNum ? 'font-mono text-right' : ''}`}>
                      {typeof val === 'number' ? formatMetricValue(val, c) : val === null || val === undefined ? '—' : formatFieldReferencesInText(String(val))}
                    </td>
                  )
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {onPageChange && data.totalRows != null && data.page != null && data.pageSize != null && (
        <PaginationBar
          page={data.page}
          totalRows={data.totalRows}
          pageSize={data.pageSize}
          onPageChange={onPageChange}
        />
      )}
    </div>
  )
}
